// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"226":"471bd3ef","328":"bd891f21","570":"ccb6896f","705":"9cb750c6"}[chunkId] + ".chunk.css";
};